import { MagnifyingGlass } from "phosphor-react-sc"
import { stopPropagation } from "../../../../../helpers/ObjectHelpers";
import MapPropertiesService from "../../../services/MapPropertiesService";
import { useSetPanelState } from "../../../hooks/useMapStore";

interface MapControlSearchProps {
    show?: boolean,
}
export const MapControlSearch = ({
    show = false,
}: MapControlSearchProps) => {

    const setPanelState = useSetPanelState();

    const panelStates = MapPropertiesService.panelStates;
    

    return (
        show &&
        <div className="google-map-control google-map-control-button" onClick={onClick}>
            <MagnifyingGlass size={20} weight="duotone" />
        </div>
    )

    function onClick(e: any) {
        stopPropagation(e);
        setPanelState(panelStates.Search);
    }
}
